import { Input } from 'smg/customer-api/promos';
import { Session } from 'smg/customer-api/session';
import { ShowError } from 'smg/errors';
import { BlockPastDates, ReportValidity } from 'smg/form';
import { Phone } from 'smg/phone';
import { GetFirstAndLast } from 'smg/users';

import * as buttons from 'smg/buttons';
import * as countries from 'smg/countries';
import * as models from 'smg/customer-api/models';
import * as quoterequests from 'smg/customer-api/quoterequests';

import { Uploader } from '../components/uploader';
import { Relref } from '../hugo';

declare interface myWindow extends Window {
    dataLayer: Record<string, unknown>[];
}
declare const window: myWindow;

main();

function main() {
    const $form = document.querySelector<HTMLFormElement>('#main-form') as HTMLFormElement;
    const $sectionSport = $form.querySelector<HTMLDivElement>('#section-sport') as HTMLDivElement;
    const $sectionTemplate = $form.querySelector<HTMLDivElement>('#section-template') as HTMLDivElement;
    const $sectionSize = $form.querySelector<HTMLDivElement>('#section-size') as HTMLDivElement;
    const $sectionPlating = $form.querySelector<HTMLDivElement>('#section-plating') as HTMLDivElement;
    const $sectionUpgrades = $form.querySelector<HTMLDivElement>('#section-upgrades') as HTMLDivElement;
    const $sectionContact = $form.querySelector<HTMLDivElement>('#section-contact') as HTMLDivElement;

    const $fieldset = $form.querySelector<HTMLFieldSetElement>('#trading-quote-form-fieldset') as HTMLFieldSetElement;

    const $sportBaseball = $sectionSport.querySelector<HTMLInputElement>('#sport-baseball') as HTMLInputElement;
    const $sportSoftball = $sectionSport.querySelector<HTMLInputElement>('#sport-softball') as HTMLInputElement;

    const $tradingQuoteQuantity = $sectionContact.querySelector<HTMLInputElement>('#trading-quote-quantity') as HTMLInputElement;
    const $tradingQuoteTeamName = $sectionContact.querySelector<HTMLInputElement>('#trading-quote-team-name') as HTMLInputElement;
    const $tradingQuoteTeamColors = $sectionContact.querySelector<HTMLInputElement>('#trading-quote-team-colors') as HTMLInputElement;
    const $tradingQuoteUploadLabel = $sectionContact.querySelector<HTMLLabelElement>('.uploader-dropzone') as HTMLLabelElement;
    const $tradingQuoteNotes = $sectionContact.querySelector<HTMLTextAreaElement>('#trading-quote-notes') as HTMLTextAreaElement;
    const $tradingQuoteName = $sectionContact.querySelector<HTMLInputElement>('#trading-quote-name') as HTMLInputElement;
    const $tradingQuoteEmail = $sectionContact.querySelector<HTMLInputElement>('#trading-quote-email') as HTMLInputElement;
    const $tradingQuotePhone = $sectionContact.querySelector<HTMLInputElement>('#trading-quote-phone') as HTMLInputElement;
    const $tradingQuoteState = $sectionContact.querySelector<HTMLSelectElement>('#trading-quote-state') as HTMLSelectElement;
    const $tradingQuoteDate = $sectionContact.querySelector<HTMLInputElement>('#trading-quote-date') as HTMLInputElement;
    BlockPastDates($tradingQuoteDate, { earliest: 'tomorrow' });
    const $tradingQuotePromo = $sectionContact.querySelector<HTMLInputElement>('#trading-quote-promo') as HTMLInputElement;

    const $promoCodeSuccess = document.querySelector('#promo-code-success') as HTMLElement;
    const $promoCodeTitle = $promoCodeSuccess.querySelector('#promo-code-title') as HTMLElement;
    const $promoCodeDescription = $promoCodeSuccess.querySelector('#promo-code-description') as HTMLElement;

    const $tradingQuoteFormSubmit = $form.querySelector<HTMLButtonElement>('#trading-quote-form-submit') as HTMLButtonElement;

    const uploader = new Uploader($tradingQuoteUploadLabel);
    const phone = new Phone($tradingQuotePhone);

    $form.reset();

    const promo = new Input($tradingQuotePromo, {
        success: p => {
            $promoCodeTitle.textContent = p.name;
            $promoCodeDescription.textContent = p.description;
            $promoCodeSuccess.classList.remove('d-none');
        },
        error: () => {
            $promoCodeSuccess.classList.add('d-none');
            $promoCodeTitle.textContent = '';
            $promoCodeDescription.textContent = '';
        },
    });

    countries.StateSelect(models.CountryID.COUNTRIES_UNITED_STATES, $tradingQuoteState).catch(ShowError);

    $sectionSport.addEventListener('change', () => {
        if (!$sectionSport.querySelector('input:checked')) {
            return;
        }

        const isSoftball = $sportSoftball.checked;
        $form.querySelectorAll<HTMLElement>('.baseball-img').forEach($img => $img.classList.toggle('d-none', isSoftball));
        $form.querySelectorAll<HTMLElement>('.softball-img').forEach($img => $img.classList.toggle('d-none', !isSoftball));

        if ($sectionTemplate.classList.contains('d-none')) {
            $sectionTemplate.classList.remove('d-none');
            $sectionTemplate.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    });

    $sectionTemplate.addEventListener('change', () => {
        if ($sectionTemplate.querySelector('input:checked') && $sectionSize.classList.contains('d-none')) {
            $sectionSize.classList.remove('d-none');
            $sectionSize.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    });

    $sectionSize.addEventListener('change', () => {
        if ($sectionSize.querySelector('input:checked') && $sectionPlating.classList.contains('d-none')) {
            $sectionPlating.classList.remove('d-none');
            $sectionPlating.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    });

    $sectionPlating.addEventListener('change', () => {
        // Upgrades are optional, so reveal it and the Contact section together once
        // plating is chosen — the form is never gated behind an upgrade selection.
        if ($sectionPlating.querySelector('input:checked') && $sectionUpgrades.classList.contains('d-none')) {
            $sectionUpgrades.classList.remove('d-none');
            $sectionContact.classList.remove('d-none');
            $sectionUpgrades.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    });

    $tradingQuoteFormSubmit.addEventListener('click', async e => {
        e.preventDefault();

        await promo.check();

        if (!ReportValidity($form)) {
            if ($sectionSport.querySelector('input.is-invalid')) {
                $sectionSport.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
            return;
        }

        $fieldset.disabled = true;
        buttons.Start($tradingQuoteFormSubmit);
        const extras: models.QuoteRequestCreateExtra[] = [];
        if ($tradingQuoteTeamName.value) {
            extras.push(new models.QuoteRequestCreateExtra({
                name: 'Team Name',
                value: $tradingQuoteTeamName.value,
            }));
        }

        if ($tradingQuoteTeamColors.value) {
            extras.push(new models.QuoteRequestCreateExtra({
                name: 'Team Colors',
                value: $tradingQuoteTeamColors.value,
            }));
        }

        if ($sportBaseball.checked) {
            extras.push(new models.QuoteRequestCreateExtra({
                name: 'Sport',
                value: 'Baseball',
            }));
        } else if ($sportSoftball.checked) {
            extras.push(new models.QuoteRequestCreateExtra({
                name: 'Sport',
                value: 'Softball',
            }));
        }

        if ($tradingQuoteState.value) {
            extras.push(new models.QuoteRequestCreateExtra({
                name: 'State',
                value: $tradingQuoteState.options[$tradingQuoteState.selectedIndex].text,
            }));
        }

        const $selectedTemplate = $sectionTemplate.querySelector<HTMLInputElement>('input:checked');
        if ($selectedTemplate) {
            extras.push(new models.QuoteRequestCreateExtra({
                name: 'Template',
                value: $selectedTemplate.value,
            }));
        }

        let size;
        const $selectedSize = $sectionSize.querySelector<HTMLInputElement>('input:checked');
        if ($selectedSize) {
            size = $selectedSize.value;
        }

        let children: models.QuoteRequestCreateChild[] | undefined = [];

        for (const $choice of $form.querySelectorAll<HTMLInputElement>('input[data-child]:checked')) {
            children.push(new models.QuoteRequestCreateChild({
                child: $choice.dataset.child,
                option: $choice.dataset.option,
                cheapestOption: $choice.hasAttribute('data-cheapest-option'),
            }));
        }

        if (!children.length) {
            children = undefined;
        }

        // Awaited outside the chain — a PUT-failure throw would otherwise skip
        // the catch/finally below and leave the form disabled.
        let uploadIDs: number[];
        try {
            uploadIDs = await uploader.getUploadIDs();
        } catch (err) {
            ShowError(err);
            $fieldset.disabled = false;
            buttons.Stop($tradingQuoteFormSubmit);
            return;
        }

        quoterequests.NewQuoteRequest({
            form: 'trading pin quote form',
            name: $tradingQuoteName.value,
            company: $tradingQuoteTeamName.value,
            phone: await phone.format(),
            email: $tradingQuoteEmail.value,
            lineItem: 'Lapel Pins',
            type: 'Trading Pins',
            size,
            children,
            quantity: $tradingQuoteQuantity.value ? parseInt($tradingQuoteQuantity.value, 10) : undefined,
            promo: $tradingQuotePromo.value || undefined,
            project: `${new Date().getFullYear()} ${$tradingQuoteTeamName.value}`,
            dateNeeded: $tradingQuoteDate.value || undefined,
            notes: $tradingQuoteNotes.value || undefined,
            extras,
            uploadIDs,
        }).then(async quoteRequest => {
            const sess = await Session().catch(() => undefined);
            const dataLayer = window.dataLayer || [];
            const { firstName, lastName } = GetFirstAndLast(String($tradingQuoteName.value));
            dataLayer.push({
                'event': 'hs-module-quote-form-success',
                'userData': {
                    'email': sess?.user.emailAddress.email || $tradingQuoteEmail.value,
                    'phone': sess?.user.phoneNumber.phone || await phone.format(),
                    'firstName': sess?.user.firstName || firstName,
                    'lastName': sess?.user.lastName || lastName,
                },
                'transactionId': quoteRequest.id,
                'total': quoteRequest.quotes?.[0].cachedTotal,
            });
            window.location.href = `${Relref('/free-quote/thank-you')}?id=${quoteRequest.quotes?.[0].key ?? ''}`;
        }).catch(err => {
            ShowError(err);
            $fieldset.disabled = false;
            buttons.Stop($tradingQuoteFormSubmit);
        });
        return;
    });
}
